import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import SoftSignalIcon from 'components/SoftSignalIcon';
import { SoftSignal } from 'models/Lead';

import './SoftSignalButton.styles.scss';

type SoftSignalButtonProps = {
  className?: string;
  applied?: boolean;
  disabled?: boolean;
  softSignal: SoftSignal;
  onClick: () => void;
};

const SoftSignalButton: React.FC<SoftSignalButtonProps> = (props) => {
  const { className, children, softSignal, applied, disabled, onClick } = props;

  const classes = classNames(
    'soft-signal-button',
    softSignal,
    { applied, disabled },
    className,
  );

  return (
    <Button
      variant="icon"
      className={classes}
      onClick={() => {
        if (applied) return;
        onClick();
      }}
    >
      <SoftSignalIcon softSignal={softSignal} transparent />
      {children}
    </Button>
  );
};

export default SoftSignalButton;
